<template>
  <div class="m-modal-product-gallery">
    <SfModal :visible="isVisible" @close="closeModal">
      <div class="m-modal-product-gallery__content">
        <SfGallery
          ref="gallery"
          :images="gallery"
          :current="activeIndex + 1"
          :slider-options="{
            animationDuration: 250,
            rewindDuration: 250,
            autoplay: false,
            rewind: false,
            gap: 0,
          }"
          @click="onGalleryChange"
        />
      </div>
    </SfModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  SfModal
} from '@storefront-ui/vue';
import isEqual from 'lodash-es/isEqual';
import SfGallery from 'theme/components/molecules/modals/m-modal-product-gallery-sfgallery';

export default {
  name: 'MModalProductGallery',
  components: {
    SfModal,
    SfGallery
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    closeModal () {
      this.$emit('close', this.modalData.name)
    },
    normalizeGalleryIndex (index) {
      if (typeof index !== 'number') return 0
      return index > 0 ? index - 1 : index
    },
    onGalleryChange (index) {
      this.activeIndex = this.normalizeGalleryIndex(index)
    },
    resizeImageUrl (url, size) {
      if (!url || typeof url !== 'string') return url
      return url.replace(/\/img\/\d+\/\d+\//, `/img/${size}/${size}/`)
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getProductGallery: 'product/getProductGallery',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration'
    }),
    product () {
      return this.getCurrentProduct;
    },
    gallery () {
      const modalSize = 2000
      const modalSize1x = 1000
      const thumbSize = 280
      return this.getProductGallery.map(imageObject => {
        const isVideo = !!(imageObject.video && imageObject.video.url)
        const baseUrl = imageObject.src || imageObject.loading
        const url1x = this.resizeImageUrl(baseUrl, modalSize1x)
        const url2x = this.resizeImageUrl(baseUrl, modalSize)
        const thumbUrl = this.resizeImageUrl(baseUrl, thumbSize)
        return {
          id: imageObject.id,
          videoUrl: isVideo ? imageObject.video.url : null,
          mobile: {
            url: thumbUrl,
            alt: this.product.name
          },
          desktop: {
            url: url2x,
            alt: this.product.name
          },
          srcset: (!isVideo && url1x && url2x && url1x !== url2x)
            ? `${url1x} 1x, ${url2x} 2x`
            : null
        }
      })
    },
    configuration () {
      return this.getCurrentProductConfiguration;
    },
    variantImage () {
      let variantImage = this.gallery.find(image => {
        let selectThis = true
        for (const [key, value] of Object.entries(this.configuration)) {
          if (
            typeof image.id !== 'undefined' &&
            typeof image.id[key] !== 'undefined' &&
            image.id[key] !== value.id
          ) {
            selectThis = false
          }
        }
        return selectThis || (image.id && image.id.color && String(image.id.color) === String(this.configuration.color.id))
      })

      if (!variantImage) {
        variantImage = this.gallery.find(image => {
          return typeof image.id.color !== 'undefined' &&
            typeof this.configuration.color !== 'undefined' &&
            String(image.id.color) === String(this.configuration.color.id)
        })
      }

      if (!variantImage) {
        variantImage = this.gallery[0];
      }

      return variantImage;
    },
    currentIndex () {
      const index = this.gallery.findIndex(imageObject =>
        isEqual(imageObject.id, this.variantImage.id)
      );

      return index === -1 ? 0 : index;
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (visible) {
        if (!visible) return
        this.activeIndex = typeof this.modalData.payload === 'number'
          ? this.modalData.payload
          : this.currentIndex
      }
    },
    modalData: {
      deep: true,
      handler (modalData) {
        if (!modalData || typeof modalData.payload !== 'number') return
        this.activeIndex = modalData.payload
      }
    },
    currentIndex () {
      this.activeIndex = this.currentIndex
      this.$refs.gallery.go(this.currentIndex)
    }
  }
};
</script>
<style lang="scss" scoped>
.m-modal-product-gallery__content {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
